import NewsletterThirtyFourContainer from "./container/NewsletterThirtyFourContainer";
export default NewsletterThirtyFourContainer;
